import { useState } from 'react';
import { Globe } from 'lucide-react';
import { Button } from './ui/button';
import { languages, type LanguageCode, changeLanguage, getLanguageFromPath, detectBrowserLanguage } from '../utils/i18n';

export function LanguageSwitcher() {
    const [isOpen, setIsOpen] = useState(false);
    const currentLang = getLanguageFromPath() || detectBrowserLanguage();
    const currentLanguage = languages[currentLang];

    const handleLanguageChange = (lang: LanguageCode) => {
        changeLanguage(lang);
        setIsOpen(false);
    };

    const getFlagUrl = (code: string) => {
        const countryCode = code.split('-')[1].toLowerCase();
        return `https://flagcdn.com/w40/${countryCode}.png`;
    };

    return (
        <div className="relative">
            <Button
                variant="ghost"
                size="sm"
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center gap-2"
            >
                <Globe className="size-4" />
                <img
                    src={getFlagUrl(currentLanguage.code)}
                    alt={currentLanguage.name}
                    className="w-5 h-3.5 object-cover rounded-[1px]"
                />
                <span className="hidden md:inline">{currentLanguage.name}</span>
            </Button>

            {isOpen && (
                <>
                    {/* Overlay para fechar ao clicar fora */}
                    <div
                        className="fixed inset-0 z-40"
                        onClick={() => setIsOpen(false)}
                    />

                    {/* Dropdown */}
                    <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
                        {Object.values(languages).map((lang) => (
                            <button
                                key={lang.code}
                                onClick={() => handleLanguageChange(lang.code as LanguageCode)}
                                className={`w-full px-4 py-2 text-left hover:bg-gray-100 transition-colors flex items-center gap-3 ${lang.code === currentLang ? 'bg-purple-50 text-purple-700' : 'text-gray-700'
                                    }`}
                            >
                                <img
                                    src={getFlagUrl(lang.code)}
                                    alt={lang.name}
                                    className="w-6 h-4 object-cover rounded-[2px] shadow-sm"
                                />
                                <span className="font-medium">{lang.name}</span>
                                {lang.code === currentLang && (
                                    <span className="ml-auto text-purple-600">✓</span>
                                )}
                            </button>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
}
